import useLazyData from '@/hooks/useLazyData';
import { ComponentProps, ISize } from '@/types/cms';
import classNames from 'classnames';
import { FC } from 'react';

import TitleSkeleton from './skeleton';
import { twMerge } from 'tailwind-merge';

const Title: FC<ComponentProps> = props => {
  const { properties } = props;

  const { ref, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '15px 0px 0px 0px'
  });

  if (!show) {
    return <TitleSkeleton viewRef={ref} />;
  }

  return (
    <h2
      data-module={props.cmsComponentKey}
      style={{ color: `${properties?.color}`, textAlign: properties?.align }}
      className={twMerge(
        classNames('tracking-[0.38px] leading-[125%] font-semibold mx-0 my-2.5 px-5 py-0', {
          'my-2.5': properties?.vertical_margin === ISize.small,
          'my-5': properties?.vertical_margin === ISize.middle,
          'my-10': properties?.vertical_margin === ISize.large,
          ['text-sm']: properties?.font_size === (ISize.small as string),
          ['text-base']: properties?.font_size === (ISize.middle as string),
          ['text-xl']: properties?.font_size === (ISize.large as string)
        })
      )}>
      {properties?.text}
    </h2>
  );
};

export default Title;
